<template>

  <div class="card shadow"
       :class="type === 'dark' ? 'bg-default': ''">
    <div class="card-header border-0"
         :class="type === 'dark' ? 'bg-transparent': ''">
      <div class="row align-items-center">
        <div class="col">
          <h3 class="mb-0" :class="type === 'dark' ? 'text-white': ''">
          </h3>
        </div>
      </div>
    </div>

    <div class="table-responsive">
      <base-table class="table align-items-center table-flush"
                  :class="type === 'dark' ? 'table-dark': ''"
                  :thead-classes="type === 'dark' ? 'thead-dark': 'thead-light'"
                  tbody-classes="list"
                  :data="creditPackageTransactions">
        <template slot="columns">
          <th class="text-center">Transaction ID</th>
          <th class="text-center">Package Name - Credit</th>
          <th class="text-center">Amount (BND)</th>
          <th class="text-center">Company</th>
          <th class="text-center">Transaction Date</th>
          <th class="text-center">Payment Status</th>
          <!-- <th class="text-center"></th> -->
        </template>

        <template slot-scope="{row, index}">
          <td scope="row" class="text-center">
            <div class="media align-items-center">
              <div class="media-body">
                <span class="name mb-0 text-sm text-danger" v-if="row.status == 2">{{index+1+(10*(pageNumber-1))}}</span>
                <span class="name mb-0 text-sm" v-else>{{index+1+(10*(pageNumber-1))}}</span>
              </div>
            </div>
          </td>
          <td scope="row" class="text-center">
            <div class="media align-items-center">
              <div class="media-body">
                <span class="name mb-0 text-sm text-danger" v-if="row.status == 2">{{row.package_name}}</span>
                <span class="name mb-0 text-sm" v-else>{{row.package_name}}</span>
              </div>
            </div>
          </td>
          <td scope="row" class="text-center">
            <div class="media align-items-center">
              <div class="media-body">
                <span class="name mb-0 text-sm text-danger" v-if="row.status == 2">{{row.total}}</span>
                <span class="name mb-0 text-sm" v-else>{{row.total}}</span>
              </div>
            </div>
          </td>
          <td scope="row" class="text-center">
            <div class="media align-items-center">
              <div class="media-body">
                <span class="name mb-0 text-sm text-danger" v-if="row.status == 2">{{row.company_name}}</span>
                <span class="name mb-0 text-sm" v-else>{{row.company_name}}</span>
              </div>
            </div>
          </td>
          <td scope="row" class="text-center">
            <div class="media align-items-center">
              <div class="media-body">
                <span class="name mb-0 text-sm text-danger" v-if="row.status == 2">{{row.transaction_date}}</span>
                <span class="name mb-0 text-sm" v-else>{{row.transaction_date}}</span>
              </div>
            </div>
          </td>
          <td scope="row" class="text-center">
            <div class="media align-items-center">
              <div class="media-body">
                <span class="name mb-0 text-sm" v-if="row.status == 0">Pending</span>
                <span class="name mb-0 text-sm" v-if="row.status == 1">Paid</span>
                <span class="name mb-0 text-sm text-danger" v-if="row.status == 2">Fail</span>
              </div>
            </div>
          </td>

          <!-- <td class="text-center">
            <base-dropdown class="dropdown"
                           position="center">
              <a slot="title" class="btn btn-sm btn-icon-only text-light" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                <i class="fas fa-ellipsis-v"></i>
              </a>

              <template>
                <a class="dropdown-item" href="#" @click="">View</a>
              </template>
            </base-dropdown>
          </td> -->

        </template>

      </base-table>
    </div>

    <div class="card-footer d-flex justify-content-end"
         :class="type === 'dark' ? 'bg-transparent': ''">
      <base-pagination :perPage="10" :total="totalCreditPackageTransaction" :value="pageNumber"></base-pagination>
    </div>

  </div>
</template>
<script>
  export default {
    name: 'credit-package-transactions-table',
    props: {
      type: {
        type: String
      },
      title: String
    },
    data() {
      return {
        totalCreditPackageTransaction: 0
      }
    },
    computed: {
      creditPackageTransactions()
      {
        return this.$store.getters.creditPackageTransactions;
      },
      pageNumber()
      {
        return parseInt(this.$route.query.page);
      },
      totalCreditPackageTransactions()
      {
        return this.totalCreditPackageTransaction;
      }
    },
    watch: {
      pageNumber() {
        this.getCreditPackageTransactions(this.$route.query.page);
      }
    },
    mounted() {
      this.getCreditPackageTransactions(1);
      this.getTotalCreditPackageTransactions();
    },
    methods: {
      getCreditPackageTransactions : function (page_number) {
        this.$store.dispatch('fetchCreditPackageTransactions', page_number).then (response => {
          this.$store.dispatch('updateState', {
              key : 'creditPackageTransactions',
              value : response.data
          });
        });
      },

      getTotalCreditPackageTransactions()
      {
        this.$store.dispatch('fetchTotalCreditPackageTransaction').then (response => {
          this.totalCreditPackageTransaction = parseInt(response.data);
        });
      }
    }
  }
</script>
<style>
</style>
